import { css } from "@emotion/css";
import { Text } from "../../../components/common";
import React from "react";
import Bg from "../assets/podcastBg.png";
import { format } from "date-fns";

const currentDate = format(new Date(Date.now()), "EEEE, MMMM do");

type Props = {
  lastUpdated: string;
};
export const PodcastHeader: React.FC<Props> = ({ lastUpdated }) => {
  return (
    <header
      className={css`
        height: 200px;
        width: 100%;
        background-image: url(${Bg});
        background-size: cover;
        background-position: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 16px;
        @media (max-height: 700px) {
          max-height: 123px;
        }
      `}
    >
      <Text.Body2XS style={{ textTransform: "uppercase" }}>
        {currentDate}
      </Text.Body2XS>
      <Text.Body3XS color="seconday">Last updated: {lastUpdated}</Text.Body3XS>
      <Text.H1 style={{ fontSize: "32px" }}>Multiplayer Podcast</Text.H1>
    </header>
  );
};
